<template id="vTable">
  <div>
    <v-card id="cardShop">

      <v-data-table
        :headers="headers"
        style="font-family: anjoman !important;font-weight: normal!important;margin-bottom: 50px"
        :items="desserts"
        loading-text="در حال بروز رسانی. لطفا اندکی صبر کنید"
        class="elevation-1 mytable"
        @update:options="updateTable($event)"
        :server-items-length="rowCount"
      >
        <!--    <v-progress-linear v-show="progressBar" slot="progress" color="blue" indeterminate></v-progress-linear>-->
        <template v-slot:top>
          <v-toolbar
            flat
          >
            <v-toolbar-title style="font-family: anjoman !important;font-weight: normal!important;"
            >فروشگاه‌ها</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-dialog
              v-model="dialog"
              max-width="500px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="#E72480"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  افزودن
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span style="font-family: anjoman!important;" class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text style="font-family: anjoman !important;">
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          v-model="editedItem.name"
                          style="font-family: anjoman !important;font-weight: normal!important;"
                          label="نام فروشگاه"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-select
                          :items="categoryItems"
                          item-text="title"
                          item-value="id"
                          v-model="editedItem.category"
                          @change="changeCategoryItems($event)"
                          style="font-family: anjoman !important;font-weight: normal!important;"
                          label="دسته‌بندی"
                        ></v-select>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          v-model="editedItem.floor"
                          style="font-family: anjoman !important;font-weight: normal!important;"
                          label="طبقه"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          v-model="editedItem.plate"
                          style="font-family: anjoman !important;font-weight: normal!important;"
                          label="پلاک"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          v-model="editedItem.instagram"
                          style="font-family: anjoman !important;font-weight: normal!important;"
                          label="اینستاگرام"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          v-model="editedItem.phoneNo"
                          style="font-family: anjoman !important;font-weight: normal!important;"
                          label="شماره‌تماس"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-file-input
                          v-model="imageFile"
                          style="font-family: anjoman !important;font-weight: normal!important;"
                          label="تصویر"
                          v-on:change="showImage($event)"
                          v-on:click:clear="deleteImage"
                        >
                          <template v-slot:selection="{ index, text }">
                            <v-chip
                              color="#E72480"
                              dark
                              label
                              small
                              style="color: white"
                            >
                              1-files
                            </v-chip>
                          </template>
                        </v-file-input>
                      </v-col>
                      <div style="display: grid;justify-content: center;align-items: center;margin-left: 40px" >
                      <v-img v-if="image" width="75" height="50" :src="image" alt="images"></v-img>
                      </div>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                      >
                        <v-select
                           :items="categoryStoreItems"
                           v-model="editedItem.subCategories"
                           item-text="name"
                           item-value="id"
                           hide-details
                           multiple
                           :loading="loadingCategory"
                           :disabled="editedItem.category===0 || !editedItem.category"
                           style="font-family: anjoman !important;font-weight: normal!important;"
                           label="دسته بندی جزئی"
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip color="#E72480" v-if="index === 0">
                              <span style="color: white">{{ item.name }}</span>
                            </v-chip>
                            <span
                              v-if="index === 1"
                              class="black--text"
                              style="font-family: anjoman !important;font-size: 12px"
                            >
                              ( {{'بقیه ها'}} {{changeEnglishToPersian(editedItem.subCategories.length - 1)}}+      )
                            </span>
                          </template>
                        </v-select>
                        <div style="color: red;width: 120%;font-size: 12px" v-if="!editedItem.category">لطفا دسته بندی را انتخاب کنید </div>
                      </v-col>
                    </v-row>
                  </v-container>

                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#E72480"
                    text
                    @click="close"
                  >
                    لغو
                  </v-btn>
                  <v-btn
                    color="#E72480"
                    text
                    @click="save"
                    :loading="saveLoading"
                  >
                    ذخیره
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title style="font-family: anjoman !important;font-weight: normal!important;" class="headline">آيا از حذف این فروشگاه مطمئن می‌باشید؟</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn style="font-family: anjoman !important;font-weight: normal!important;" color="#E72480" text @click="closeDelete">لغو</v-btn>
                  <v-btn :loading="deleteLoading" style="font-family: anjoman !important;font-weight: normal!important;" color="#E72480" text @click="deleteItemConfirm">تایید</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.subCategories="{item}">
          <p class="mt-1" v-for="(item, index) in item.subCategories" :key="index">{{item.name}}</p>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn class="ml-2"   @click="editItem(item)" icon plain text elevation="2" >
            <v-icon
              small
              color="blue"
            >
              mdi-pencil
            </v-icon>
          </v-btn>
            <v-btn  @click="deleteItem(item)" icon text elevation="2" plain>
            <v-icon
              small
              color="red"
            >
              mdi-delete
            </v-icon>
            </v-btn>

        </template>
        <template v-slot:item.file="{item}">
          <v-img v-if="item.file" lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU" alt="تصویر فروشگاه" width="75" height="50" :src="url+item.file">
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </template>
        <template v-slot:no-data>
          <v-btn
            color="primary"
            @click="getShopsData"
          >
            تنظیم مجدد
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
<!-- disable the category -->
<!--    <category></category>-->
  </div>
</template>

<script>
  import {getShops , putShops , setShops , deleteShops} from '../../../api/shops'
  import {toBase64} from "../../../plugins/toBase64";
  import category from "./category";
  import {mapActions} from "vuex";
  import {getCategory,getSubCategory} from "../../../api/category";
  import {toFarsiNumber} from "../../../plugins/toFarsiNumber";

  export default {
    name: "shops",
    components:{
      category
    },
    data: () => ({
      deleteLoading:false,
      saveLoading:false,
      progressBar: true,
      loadingCategory:false,
      rowCount: null,
      res : null,
      page:1,
      pagesSize:5,
      dialog: false,
      dialogDelete: false,
      imageFile:null,
      image:"",
      headers: [
        { text: 'تصویر', value: 'file' ,sortable: false, },

        {
          text: 'نام فروشگاه',
          align: 'start',

          value: 'name',
        },
        { text: 'طبقه', value: 'floor' },
        { text: 'پلاک', value: 'plate' },
        { text: 'آدرس اینستاگرام', value: 'instagram' ,sortable: false, },
        { text: 'شماره تماس', value: 'phoneNo' ,sortable: false, },
        { text: 'دسته بندی', value: 'category.title' ,sortable: false, },
        { text: 'دسته بندی جزئی', value: 'subCategories' ,sortable: false, },

        { text: 'حذف - ویرایش', value: 'actions', sortable: false , width:'150'},
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        id: 0,
        name: '',
        floor: '',
        plate: '',
        instagram: '',
        phoneNo: '',
        category: 0,
        subCategories:[],
        location:'',
        file:null,
        image:'',

      },
      categoryItems: [{id:0,text:"لباس"},{id:1,text:"لوازم خانگی"},{id:2,text:"تشریفات"}],
      categoryStoreItems:[{id:0,text:'لباس مردانه'},{id:1,text:'لباس زنانه'},{id:2,text:'پچگانه'},{id:3,text:'اکسسوزی'},{id:4,text:'اسپرت'},],

      url: process.env.VUE_APP_BASE_URL,
      // page: {},
      perPage: null,
      defaultItem: {
        id: 0,
        name: '',
        floor: '',
        plate: '',
        instagram: '',
        phoneNo: '',
        category: 0,
        subCategories:[],
        location:'',
        file:null,
        image:'',

      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'اضافه کردن فروشگاه' : 'تصحیح فروشگاه'
      },
      // ...mapGetters({
      //   shopsGetter: 'shopsStore/shopsGetter',
      // })
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      // page: function () {
      //   this.getShopsData()
      // }
    },

   async mounted () {

      this.url = process.env.VUE_APP_BASE_URL
      this.categoryItems = await  getCategory()
      this.setLoading(true)
      await this.getShopsData()
      this.setLoading(false)
    },

    methods: {
      changeEnglishToPersian(number)
      {
        return toFarsiNumber(number)
      },
        async changeCategoryItems(e){
         this.categoryStoreItems = await getSubCategory(e)
          this.editedItem.subCategories = []
        },
      showImage(e){
        if(e) {
          this.image = URL.createObjectURL(e)
        }
      },
      deleteImage()
      {
        this.image = ''
      },
      ...mapActions({
        snackBarAction: 'snackBar/snackBarAction',
        setLoading : 'setLoading'

      }),


      async getShopsData () {
        // if (this.itemsPerPage !== null)
        // this.desserts = await getShops(this.page , this.pagesSize)
        await this.refresh()
        // this.shopsGetter
        // this.page.itemsPerPage = this.desserts.pageSize
        this.progressBar=  false
      },

      async editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        if (this.editedItem.category) {
          this.categoryStoreItems = await getSubCategory(this.editedItem.category.id)
        }
        this.dialog = true
        this.image=''
        this.imageFile=[]
      },

      deleteItem (item) {
        // this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      async deleteItemConfirm () {
        this.deleteLoading = true
        // this.desserts.splice(this.editedIndex, 1)
        try {
          await deleteShops(this.editedItem.id)
          this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات حذف با موفقیت اعمال شد', showSnackbar:true})

        }
        catch{
          this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})

        }

        await this.refresh()

        this.closeDelete()
        this.deleteLoading =false
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
        this.image=''
        this.imageFile=[]
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
        this.image=''
        this.imageFile=[]
      },

      async save () {
        this.saveLoading =true
        if (this.editedIndex > -1) {
          // Object.assign(this.desserts[this.editedIndex], this.editedItem)
          this.editedItem.file = this.imageFile ? await toBase64(this.imageFile) : undefined
          try {
            if( (typeof this.editedItem.category === "object" || typeof this.editedItem.category === 'function') && (this.editedItem.category !== null) )
            {
              this.editedItem.category = this.editedItem.category.id
            }
            if( (typeof this.editedItem.subCategories[0] === "object" || typeof this.editedItem.subCategories[0] === 'function') && (this.editedItem.subCategories[0] !== null) )
            {
              for (let i = 0; i <this.editedItem.subCategories.length ; i++) {
                 this.editedItem.subCategories[i] = this.editedItem.subCategories[i].id
              }
            }
            await putShops(this.editedItem , this.editedItem.id)
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات ویرایش با موفقیت اعمال شد', showSnackbar:true})
          }
          catch (e) {
            this.snackBarAction({color:"error" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          }
          this.close()
          await this.refresh()
        }
        else {
          this.editedItem.file = this.imageFile ? await toBase64(this.imageFile) : undefined
          try {
            await setShops(this.editedItem)
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات افزودن  با موفقیت اعمال شد', showSnackbar:true})

          }
          catch (e) {
            this.snackBarAction({color:"error" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          }
          this.close()
          await this.refresh()
        }
        this.saveLoading = false
      },
      async refresh()
      {
        this.setLoading(true)
        try{
          this.res = await getShops(this.page,this.pagesSize)
          this.desserts = this.res.results
          this.rowCount = this.res.rowCount
        }
        catch (error) {
          // console.log(error);
        }
        this.setLoading(false)
      },
      async updateTable ( changeTableEvent){
        this.page = changeTableEvent.page;
        this.pagesSize = changeTableEvent.itemsPerPage;
        await this.refresh()
      },

    },


  }
</script>
<style>
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: black !important;
}
</style>
<style scoped>
  #cardShop{
    width: 85.5%;
    margin: 0 auto;
  }


</style>
